import { getDashboardOptions } from '$tablet-app/src/app/dashboard/functions/getDashboardOptions';
import { saveUserDashboardFromTemplate } from '$tablet-app/src/app/dashboard/functions/saveUserDashboardFromTemplate';
import { RootStackScreenProps } from '$tablet-app/src/app/navigation/RootStackNavigator';
import { useRootStackNavigation } from '$tablet-app/src/app/navigation/hooks';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { getCurrentUserID } from '$tablet-app/src/app/users/functions';
import {
  useCreateDashboard,
  useUpdateDashboard,
} from '@akin-home/dashboards/react';
import { ensureError } from '@akin-home/errors';
import { showErrorToast } from '@akin-home/toast/native';
import { useBool } from '@akin-home/utils/react';
import { useEffect, useMemo, useState } from 'react';
import { ChooseHomeScreenView } from './ChooseHomeScreenView';

export function ChooseHomeScreen(props: RootStackScreenProps<'Onboarding'>) {
  const sendMessage = useStateStore((state) => state.sendChatBackgroundMessage);
  const [selected_dashboard_id, setSelectedDashboardId] = useState('');
  const navigation = useRootStackNavigation();
  const [saving, setIsSaving, setNotSaving] = useBool();
  const createDashboard = useCreateDashboard();
  const updateDashboard = useUpdateDashboard();

  const dashboard_items = useMemo(() => getDashboardOptions(), []);

  async function onPressContinue() {
    if (selected_dashboard_id) {
      const dashboard_template = dashboard_items.find(
        (item) => item.id === selected_dashboard_id
      );
      const user_id = getCurrentUserID();
      if (!dashboard_template) return;
      setIsSaving();

      try {
        await saveUserDashboardFromTemplate({
          user_id,
          dashboard_template,
          update: updateDashboard.mutateAsync,
          create: createDashboard.mutateAsync,
        });

        sendMessage('Onboarding_flow_Pixi_interactivity_level');
        props.navigation.navigate('Main', { screen: 'Home' });
      } catch (ex) {
        setNotSaving();
        showErrorToast({ text1: ensureError(ex).message });
      }
    } else {
      showErrorToast({ text1: 'Please select a home screen' });
    }
  }

  function onPressCustomize() {
    navigation.replace('EditHomeScreen');
  }

  useEffect(() => {
    sendMessage('Onboarding_flow_log_in_success');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChooseHomeScreenView
      saving={saving}
      dashboard_options={dashboard_items}
      selected_dashboard_id={selected_dashboard_id}
      onPressDashboard={setSelectedDashboardId}
      onPressContinue={onPressContinue}
      onPressCustomize={onPressCustomize}
    />
  );
}
